export default __webpack_public_path__ + "static/media/edit-user-disabled.4e7b20bb.svg";